import { useMsal } from '@azure/msal-react';
import TenantApi from '../../api/tenant/tenant-api-factory';
import { useState, useEffect, useMemo, createContext } from "react";
import LoadingAnimation from "../../components/loading/loading";
import { Link } from 'react-router-dom';
import { RentTrackerContainer } from '../../components/tenants/rent-tracker-container';
import UserApi from '../../api/user//user-api-factory';
import GraphApi from './../../api/graph/graph-api';

export const RentTrackerContext = createContext();

export const RentTracker = () => {

    const { instance, inProgress, accounts } = useMsal();
    const api = useMemo(() => new TenantApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);
    const graphApi = useMemo(() => new GraphApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);
    const userApi = useMemo(() => new UserApi(instance, inProgress, accounts, false), [instance, inProgress, accounts]);

    const [fetchInProgress, setFetchInProgress] = useState(false);
    const [fetchComplete, setFetchComplete] = useState(false);

    const [myProfile, setMyProfile] = useState(null);
    const [fetchingUserData, setFetchingUserData] = useState(false);
    const [fetchUserDataComplete, setFetchUserDataComplete] = useState(false);

    const [rentData, setRentData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setFetchInProgress(true);
            const data = await api.getRentReport();
            setRentData(data);
            setFetchInProgress(false);
            setFetchComplete(true);
        };
        if (!fetchInProgress && !fetchComplete) {
            fetchData();
        }
    }, [api, fetchInProgress, fetchComplete]);

    useEffect(() => {
        const fetchUserData = async () => {
            setFetchingUserData(true);
            
            try {
                const graphUser = await graphApi.getMeDetails();
                if (graphUser) {
                    const backendUserId = graphUser.objectId || graphUser.id;
                    if (backendUserId) {
                        const systemUsr = await userApi.user(backendUserId);
                        setMyProfile(systemUsr);
                    }
                }
            } finally {
                setFetchingUserData(false);
                setFetchUserDataComplete(true);
            }
        };

        if (graphApi && userApi && !fetchingUserData && !fetchUserDataComplete) {
            fetchUserData();
        }
    }, [graphApi, userApi, accounts, fetchingUserData, fetchUserDataComplete]);

    const getMonthYearString = date => {
        const newDate = new Date(date);
        const month = `${newDate.getFullYear()}-${('0' + (newDate.getMonth() + 1)).slice(-2)}`;
        return month;
    };

    const saveMonthLine = async dto => {
        const data = await api.saveRentTrackerDTO(dto);
        setRentData(data);
    };

    return (
        <>
            <ol className="breadcrumb float-xl-end">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active"><Link to="/tenant/rent-tracker">Rent Tracker</Link></li>
            </ol>
            <h1 className="page-header">Manage Rents | <small>check tenants have paid their rent and allocate payments to due amounts.</small></h1>

            {fetchInProgress && <LoadingAnimation />}
            {!fetchInProgress && rentData &&
                <RentTrackerContext.Provider value={{ rentData, setRentData, myProfile, saveMonthLine, getMonthYearString }}>
                    <RentTrackerContainer />
                </RentTrackerContext.Provider>
            }
            {!fetchInProgress && !rentData && <>Nothing to show... you may not have permission to view this data</>}

        </>
    );
};